import { useFormikContext } from 'formik';
import { getFixedT } from 'i18next';
import React, { useCallback, useContext, useMemo } from 'react';

import { getPerimeterOptions } from '../../../../../config';
import { CatalogsContext } from '../../../../../context';
import { EstateSearchSelect } from '../../../../EstateSearch/ImmobilienApi/EstateSearchSelect/EstateSearchSelect';

const t = getFixedT(null, 'core-immobilien');

const DEFAULT_ANY_VALUE = Number.MAX_VALUE;

type FormValues = {
  perimeter: number | null;
};

type PerimeterFilterProps = {
  fieldName?: keyof FormValues;
};

export const PerimeterFilter: React.FC<PerimeterFilterProps> = ({ fieldName = 'perimeter' }) => {
  const { values, setFieldTouched, setFieldValue } = useFormikContext<FormValues>();
  const { radii: catalogsRadii } = useContext(CatalogsContext);

  const normalizePerimeterValue = (value: FormValues['perimeter']) => {
    return value === DEFAULT_ANY_VALUE ? null : value;
  };

  const handlePerimeterChange = useCallback(
    (value: FormValues['perimeter']) => {
      setFieldTouched(fieldName, true);
      setFieldValue(fieldName, normalizePerimeterValue(value), true);
    },
    [fieldName, setFieldTouched, setFieldValue]
  );

  const formatPerimeterValue = useCallback(
    (value: FormValues['perimeter']) => t('estateSearch.perimeter', { value }),
    []
  );

  const items = useMemo(() => {
    return getPerimeterOptions(t, catalogsRadii);
  }, [catalogsRadii]);

  return (
    <EstateSearchSelect
      testId="perimeter"
      label={t('perimeter')}
      initialValue={values[fieldName]}
      items={items}
      onChange={handlePerimeterChange}
      formatValue={formatPerimeterValue}
      variant="outlined"
      className="perimeter-select"
    />
  );
};

PerimeterFilter.displayName = 'PerimeterFilter';
